/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpgatesAddonProvisionProjectRequest
 */
export interface UpgatesAddonProvisionProjectRequest {
    /**
     * 
     * @type {string}
     * @memberof UpgatesAddonProvisionProjectRequest
     */
    token: string;
    /**
     * 
     * @type {string}
     * @memberof UpgatesAddonProvisionProjectRequest
     */
    projectId: string;
}

/**
 * Check if a given object implements the UpgatesAddonProvisionProjectRequest interface.
 */
export function instanceOfUpgatesAddonProvisionProjectRequest(value: object): value is UpgatesAddonProvisionProjectRequest {
    if (!('token' in value) || value['token'] === undefined) return false;
    if (!('projectId' in value) || value['projectId'] === undefined) return false;
    return true;
}

export function UpgatesAddonProvisionProjectRequestFromJSON(json: any): UpgatesAddonProvisionProjectRequest {
    return UpgatesAddonProvisionProjectRequestFromJSONTyped(json, false);
}

export function UpgatesAddonProvisionProjectRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpgatesAddonProvisionProjectRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'token': json['token'],
        'projectId': json['projectId'],
    };
}

export function UpgatesAddonProvisionProjectRequestToJSON(json: any): UpgatesAddonProvisionProjectRequest {
    return UpgatesAddonProvisionProjectRequestToJSONTyped(json, false);
}

export function UpgatesAddonProvisionProjectRequestToJSONTyped(value?: UpgatesAddonProvisionProjectRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'token': value['token'],
        'projectId': value['projectId'],
    };
}

